/** Local notifications are not supported on web. */
export default function VerseOfDaySettings() {
  return null;
}
